export default __webpack_public_path__ + "static/media/circle.24b6207c.svg";